import {IPaginationContext, PaginationContext} from 'plugins/modules/pagination/context';
import React, {FC, ReactNode} from 'react';

interface IProps extends IPaginationContext {
    children: ReactNode;
}

export const PaginationProvider: FC<IProps> = ({children, ...restPaginationContextProps}) => {
    return <PaginationContext.Provider value={restPaginationContextProps}>{children}</PaginationContext.Provider>;
};
